import { Link } from 'react-router-dom';
import { useI18n } from 'core/i18n/I18nProvider';
import { paths } from 'core/routing/paths';
import { WelcomeIllustration } from 'shared/assets/illustrations';
import { Card, HeroBand } from 'shared/components/Feedback';
import { PageMeta } from 'shared/components/PageMeta';

export function WelcomePage() {
  const { t } = useI18n();
  return (
    <div className="welcome-page">
      <PageMeta titleKey="meta.welcome" />
      <HeroBand
        tone="brand"
        kicker={t('welcome.kicker')}
        title={t('welcome.title')}
        body={t('welcome.body')}
        actions={(
          <>
            <Link className="btn btn-primary btn-lg" to={paths.auth}>{t('welcome.cta')}</Link>
            <Link className="btn btn-outline" to={paths.terms}>{t('nav.terms')}</Link>
          </>
        )}
        art={<WelcomeIllustration />}
      />
      <p className="muted legal-hint">{t('welcome.legalHint')}</p>
      <section className="welcome-points" aria-labelledby="welcome-features">
        <h2 id="welcome-features" className="sr-only">{t('welcome.featuresTitle')}</h2>
        {[1, 2, 3].map((index) => (
          <article key={index} className="card">
            <h2>{t(`welcome.point${index}Title`)}</h2>
            <p>{t(`welcome.point${index}Body`)}</p>
          </article>
        ))}
      </section>
      <section className="welcome-how">
        <Card>
          <h2>{t('welcome.howTitle')}</h2>
          <p>{t('welcome.howBody')}</p>
        </Card>
      </section>
      <section className="welcome-consult">
        <Card>
          <h2>{t('welcome.consultTitle')}</h2>
          <p>{t('welcome.consultBody')}</p>
          <Link className="btn btn-secondary" to={paths.auth}>{t('actions.login')}</Link>
        </Card>
      </section>
    </div>
  );
}
